import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';

// --- AUTO-RELOAD ON CHUNK LOAD FAILURE (NEW DEPLOYMENT) ---
window.addEventListener('error', (event: ErrorEvent) => {
  if (event.message?.includes('Loading chunk')) {
    console.warn('Detected new deployment. Reloading app...');
    window.location.reload();
  }
});

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
